const TAIPEI_TIME_ZONE = 'Asia/Taipei'

// 繁盛期除夕日期表（台北时区），用于判断每年 11/1 到除夕（含）
const BUSY_SEASON_LUNAR_NEW_YEARS_EVE_MAP = Object.freeze({
  2026: '2026-02-16',
  2027: '2027-02-06',
  2028: '2028-01-25',
  2029: '2029-02-12',
  2030: '2030-02-01',
  2031: '2031-01-22',
  2032: '2032-02-10',
  2033: '2033-01-30',
  2034: '2034-02-18',
  2035: '2035-02-07',
  2036: '2036-01-27',
})

let taipeiDateFormatter

// 将年月日转换为可比较的数字，例如 20260216
function toDateKey ({ year, month, day }) {
  return year * 10000 + month * 100 + day
}

// 将 YYYY-MM-DD 解析为可比较的日期 key
function parseDateKey (dateText) {
  const [year, month, day] = dateText.split('-').map(num => Number(num))

  if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) {
    return null
  }

  return toDateKey({
    year,
    month,
    day,
  })
}

function getTaipeiDateFormatter () {
  if (taipeiDateFormatter) {
    return taipeiDateFormatter
  }

  try {
    taipeiDateFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: TAIPEI_TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
  } catch (e) {
    return null
  }

  return taipeiDateFormatter
}

// 获取台北时区的当前日期（年月日）
function getTaipeiDateParts (date) {
  const formatter = getTaipeiDateFormatter()

  if (!formatter) {
    return null
  }

  const parts = formatter.formatToParts(date)
  const dateParts = {}

  parts.forEach(part => {
    if (part.type !== 'literal') {
      dateParts[part.type] = Number(part.value)
    }
  })

  if (!dateParts.year || !dateParts.month || !dateParts.day) {
    return null
  }

  return {
    year: dateParts.year,
    month: dateParts.month,
    day: dateParts.day,
  }
}

// 读取某年的除夕日期 key
function getLunarNewYearsEveDateKey (year) {
  const lunarNewYearsEve = BUSY_SEASON_LUNAR_NEW_YEARS_EVE_MAP[year]

  if (!lunarNewYearsEve) {
    return null
  }

  return parseDateKey(lunarNewYearsEve)
}

// 繁盛期：上一年/当年 11/1（含）到当年/下一年除夕（含）
function isBusySeasonByDate (date = new Date()) {
  const today = getTaipeiDateParts(date)

  if (!today) {
    return false
  }

  const todayDateKey = toDateKey(today)
  const thisYearStartDateKey = toDateKey({
    year: today.year,
    month: 11,
    day: 1,
  })

  if (todayDateKey >= thisYearStartDateKey) {
    const nextYearLunarNewYearsEveDateKey = getLunarNewYearsEveDateKey(today.year + 1)
    return nextYearLunarNewYearsEveDateKey
      ? todayDateKey <= nextYearLunarNewYearsEveDateKey
      : false
  }

  const thisYearLunarNewYearsEveDateKey = getLunarNewYearsEveDateKey(today.year)

  if (!thisYearLunarNewYearsEveDateKey) {
    return false
  }

  const lastYearStartDateKey = toDateKey({
    year: today.year - 1,
    month: 11,
    day: 1,
  })

  return todayDateKey >= lastYearStartDateKey && todayDateKey <= thisYearLunarNewYearsEveDateKey
}

const state = {
}

const getters = {
  // 对外暴露当前是否繁盛期
  isBusySeason () {
    try {
      return isBusySeasonByDate(new Date())
    } catch (e) {
      return false
    }
  },
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
